import React, { Component, Fragment } from "react";
import { HotTable } from "@handsontable/react";
import Handsontable from "handsontable";
import "handsontable/dist/handsontable.full.css";
import { Redirect } from 'react-router-dom';
import {
    Button,
    Grid,
    GridColumn,
    Dimmer,
    Loader,
    Popup,
    Icon,
    Label,
    Modal,
    Message,
    Container,
    Menu
} from "semantic-ui-react";
import { bool, number, object, PropTypes, string } from "prop-types";
import moment from "moment";
import ClientsHeader from "./ClientsHeader";
import WarningMessage from "./../../Common/Layout/WarningMessage";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchAllClients, clearAllFilters, getRowsCountAfterFilter, discardChanges, selectedClients, addNewClient, fetchClientTypeLookUp, fetchGenerationTypeLookUp, fetchLocationLookUp, fetchTaskTypeLookUp, fetchGroupLookUp, fetchFirmSettings, fetchClientById, unlinkClients, staffAssignmentLookUp } from "./../../actions/clients/fetchAllClients";
import { filterEnabledCols } from "./../../Constants/clients/filterEnabledCols";
import { showLoader } from "./../../actions/clients/showLoader";
import { isEdited } from "./../../actions/clients/isEdited";
import { saveEdits, updateDefaultClients } from "./../../actions/clients/saveEdits";

import { colHeaders } from "./../../Constants/clients/colHeaders";
import { colWidths } from "./../../Constants/clients/colWidth";
import * as cellValidator from "../../Common/Utility/clientCellValidations ";
import { createNotification, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_WARNING, NOTIFICATION_TYPE_ERROR } from 'react-redux-notify';

import { change } from "redux-form";
import MultiSelectEditor from "../../Common/MultiSelectEditor/MultiSelectEditor";
import customDropdownRenderer from "../../Common/MultiSelectEditor/CustomDrodownRender";
import DEFAULTS from "../../Constants/lookupDefaultValues";
import setDropdownValues from "../../Common/Utility/setDropdownValues";
import * as ccr from "../Clients/clientCellRenderer";
import { XPITAX_ID } from "../../Constants/XCMConstants";
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg";
import "./../../Pages/Users/Create_User/CreateUser.css";
import ConfirmationModal from "./ConfirmationModal";
import StaffAssignmentModal from "./StaffAssignmentModal";
import { showNotification, notificationTypes } from "../../Common/Notification/showNotification";
import { messages, hotTableLicenseKey } from "../../Constants/clients/clientConstants";
import { isNullOrEmpty } from "../../Common/Utility/helperFunctions";

try {
    var userDetails = decodeURIComponent(escape(atob(localStorage.getItem("userDetails"))));
    if (userDetails) {
        userDetails = JSON.parse(userDetails);
    }
} catch (e) {
    window.location.reload();
}


var FIRM_ID = null;
var logginedUser = null;
var manageUserRights = null;
var manageUserRightsAccess = null;
var manageUserRightsModuleId = null;
var isStaffModified = false;

//Check globale user
var rightsDetails = null;
var BRANCH_ID = null;
var RIGHT_ACCESS = null;
var MODULE_ID = null;
var GLOBAL_USER = null;
var roleSupervisor_Preparer = null;

//Set the flag according to role.RoleId for SUPERVISOR = 4 and for PREPARER=5
if (userDetails.UserContext.roleId == 4 || userDetails.UserContext.roleId == 5) {
    roleSupervisor_Preparer = true;
}
else { roleSupervisor_Preparer = false; }
FIRM_ID = userDetails ? userDetails.UserContext.firmId : 0;
logginedUser = userDetails.UserContext.userId;
// Check Role based acces for the manage users landing page
// Rights Ids :: ModuleId = 4
manageUserRights = userDetails.Rights.filter(x => x.module_id == 4);
manageUserRightsAccess = manageUserRights[0].access;
manageUserRightsModuleId = manageUserRights[0].module_id;

//Check globale user
rightsDetails = userDetails.Rights.filter(x => x.module_id == 8);
BRANCH_ID = userDetails.UserContext.locationId;
RIGHT_ACCESS = rightsDetails[0].access;
MODULE_ID = rightsDetails[0].module_id;
var GLOBAL_USER = "N";
if (RIGHT_ACCESS == 1 && MODULE_ID == 8) {
    GLOBAL_USER = "Y";
}

var regexLastHyphen = /\-(?=[^\-]+$)/;

var CLIENT_ID = null;

CLIENT_ID = getRoutingSheetParameters();

function getRoutingSheetParameters() {
    const specialChars = /[?]/;
    var urlString = window.parent.location.href;
    if (specialChars.test(urlString)) {
        let paramString = urlString.split('?')[1];
        let queryString = new URLSearchParams(paramString);

        if (queryString.size > 1) {
            alert(messages.INVALID_REQUEST);
            return NaN;
        }

        for (let pair of queryString.entries()) {
            CLIENT_ID = (window.atob(pair[1]) != "undefined" && window.atob(pair[1]) != "null") ? window.atob(pair[1]) : 0;
        }
    }
    else
        CLIENT_ID = 0;

    return CLIENT_ID;
}

var RoleId = userDetails.UserContext.roleId;


function getFullName(UserContext) {
    var firstName = UserContext.firstName;
    var lastName = UserContext.lastName;
    var middleName = UserContext.middleName;
    var gen = UserContext.generationType;
    var fullName = lastName + ", " + firstName;
    fullName += middleName ? " " + middleName + "." : "";
    fullName += gen ? " " + gen + "." : "";
    return fullName;
}

class ClientsTable extends Component {
    filterUserStatus = true;
    isSelectAllChecked = false;
    isAddClientClicked = false;
    invalidInput = false;
    Columns = [];
    addClientPopup = false;
    selectedSearchFilter = null;

    constructor(props) {
        super(props);
        this.FirmLinkedToAxcess = userDetails && userDetails.UserContext.FirmLinkedToAxcess ? userDetails.UserContext.FirmLinkedToAxcess : false;
        this.hotTableComponent = React.createRef();
        this.warnNotification = {
            type: NOTIFICATION_TYPE_WARNING,
            duration: 5000,
            canDismiss: true,
        }

        this.errorNotification = {
            type: NOTIFICATION_TYPE_ERROR,
            duration: 5000,
            canDismiss: true,
        }
        this.succNotification = {
            type: NOTIFICATION_TYPE_SUCCESS,
            duration: 5000,
            canDismiss: true,
        }

        this.dummyState = {
            editedRows: [],
            updatedClients: []
        };

        this.state = {
            mychangedRows: [],
            showPopup: false,
            isUnlinkClients: false,
            validationError: {
                column: "",
                isValid: true,
                value: "",
                message: ""
            },
            showStaffAssignmentPopup: false,
            staffDet: [],
            selectedRowDet: []
        };

        if (!this.settings)
            this.settings = {
                licenseKey: hotTableLicenseKey
            };
    }

    disableHeaderCheckBox(isDisabled) {
        let checkboxOption = "";
        checkboxOption =
            "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='0' title='Select Up to first 50'";

        checkboxOption += isDisabled ? "disabled=true" : "";
        checkboxOption += ">";
        colHeaders[1] = checkboxOption;

    }

    setCheckBoxHeaderOptionFromSingleSelect(isALLSelected) {
        let checkboxOption = "";
        checkboxOption =
            "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='1' title='Select Up to first 50'";
        checkboxOption += isALLSelected ? "checked=true" : "";
        checkboxOption += ">";
        colHeaders[1] = checkboxOption;
    }

    setCheckBoxHeaderOption() {
        let checkboxOption = "";
        this.isSelectAllChecked = !this.isSelectAllChecked;
        checkboxOption =
            "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='1' title='Select Up to first 50'";
        checkboxOption += this.isSelectAllChecked ? "checked=true" : "";
        checkboxOption += ">";
        colHeaders[1] = checkboxOption;
    }

    componentDidMount() {
        window.onbeforeunload = () => {
            if (this.props.edited) {
                return "";
            }
        };
        if (!userDetails) {
            return;
        }

        if (this.props.clients.length > 0) {
            return;
        }
        var integrationTypeId;
        var hideColumn = false;
        this.props.showLoader(true, "Please wait. Loading data.");
        this.firmSettings = this.props.fetchFirmSettings(FIRM_ID).then((res) => {
            integrationTypeId = res.payload.firmSettings?.firmSettings?.integrationID;
            hideColumn = integrationTypeId != 4 && integrationTypeId != 6;
            this.settings = {
                licenseKey: "0b014-a057a-62a00-d4631-40c07",
                rowHeaders: true,
                manualColumnResize: true,
                filters: [],
                dropdownMenu: ["filter_action_bar", "filter_by_value"],
                observeDOMVisibility: true,
                observeChanges: false,
                stretchH: "all",
                manualColumnMove: false,
                hiddenColumns: {
                    columns: hideColumn ? [0, 17, 18, 19] : [0, 18, 19],
                    indicators: true
                },

                fillHandle: {
                    direction: "vertical",
                    autoInsertRow: false
                },
                fixedColumnsLeft: 7,
                columnSorting: true,
                multiColumnSorting: false,
                data: this.props.clients,
                headerTooltips: {
                    rows: false,
                    columns: true,
                    onlyTrimmed: false
                }

            };
        });
        this.clientTypes = this.props.fetchClientTypeLookUp();
        this.suffix = this.props.fetchGenerationTypeLookUp();
        this.locations = this.props.fetchLocationLookUp(FIRM_ID);
        this.clientGroups = this.props.fetchGroupLookUp(FIRM_ID);


        this.props.fetchTaskTypeLookUp(FIRM_ID)
            .then((res) => {
                this.props.showLoader(true, "Please wait. Loading data.");
                this.props.fetchAllClients(FIRM_ID, {
                    taskTypes: this.props.primaryTaskTypes
                }, BRANCH_ID, GLOBAL_USER, CLIENT_ID).then(() => {
                    this.props.showLoader(false);
                });
            });
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.isAddNewClient) {
            this.addNewClient();
            return false;
        }

        if (nextProps.isClearFilters) {
            this.handleClearFilters();
            return false;
        }
        return true;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    componentWillUnmount() {
    }

    ShowConfirmationPopup = () => {
        this.setState({ showPopup: true });
    }

    closeConfirmationPopup = (returngcPd) => {
        this.setState({ showPopup: false });
        this.setState({ isUnlinkClients: false });
        if (returngcPd == 0) {
            this.setState({ disableCompletebutton: true });
        }
    }

    ShowStaffAssignmentPopup = () => {
        this.setState({
            staffDet: [],
            showStaffAssignmentPopup: true
        });

    }
    closeStaffAssignmentPopup = (showNotification, cparesponsibleId, staffClientId) => {
        if (showNotification) {
            const successNotification = {
                message: `Saved Successfully`,
                ...this.succNotification
            }
            this.props.showNotification(successNotification.message, notificationTypes.SUCCESS);

        }
        this.setState({ showStaffAssignmentPopup: false });
        const hotInstance = this.hotTableComponent.current.hotInstance;
        if (cparesponsibleId > 0) {
            isStaffModified = true;
            var changedClientDet = el => el.clientId === staffClientId;
            hotInstance.getSourceData().filter(changedClientDet)[0].cparesponsibleId = cparesponsibleId;
            hotInstance.getCellMeta(hotInstance.getSourceData().findIndex(changedClientDet), 16).className = hotInstance.getCellMeta(hotInstance.getSourceData().findIndex(changedClientDet), 16).className.replaceAll(' color-wk-primary-red', '');
            hotInstance.render();
        }
    }
    redirectToAxcessProfile = (clientGuId) => {
        let url = "oip://client/" + clientGuId;
        window.open(url, "_self");
    }

    updateColumn(column) {
        if (column.selector && column.selectOptions.data == null) {
            let lookup = {
                clientTypes: this.props.clientTypes,
                suffix: this.props.suffix,
                locations: this.props.locations,
                taskTypes: this.props.primaryTaskTypes,
                clientGroups: this.props.groupNames

            }
            column.selectOptions.data = setDropdownValues({
                data: lookup,
                defaults: DEFAULTS,
                selector: column.selector,
                properties: column.properties
            });
        }
    }

    runForAllColumns() {
        this.Columns.forEach(column => this.updateColumn(column));
    }

    addNewClient = () => {
        this.dummyState.updatedClients.forEach((cli, i) => {
            cli.physicalRow++;
        });

        this.isAddClientClicked = true;
        const hotInstance = this.hotTableComponent.current.hotInstance;
        hotInstance.alter('insert_row', 0, 1);

        hotInstance.setDataAtCell(0, 0, 0);
        let defaultLocation = this.props.locations.filter(x => x.branchID == BRANCH_ID)[0].branchName;
        this.setDefaults(hotInstance, defaultLocation);
        hotInstance.setDataAtCell(0, hotInstance.propToCol("integrationStatus"), "Link");
        hotInstance.scrollViewportTo(0, 0);
        this.props.addNewClient(false);
        this.props.getRowsCountAfterFilter(hotInstance.getData().length);
    };

    setDefaults = (hotInstance, defaultLocation) => {
        let data = hotInstance.getSourceData();
        let newRows = data.filter(x => isNullOrEmpty(x.active) || isNullOrEmpty(x.branchName));
        if (newRows != null && newRows.length > 0) {
            newRows.forEach(nr => {
                let index = data.findIndex(x => x == nr);
                if (isNullOrEmpty(nr.active))
                    hotInstance.setDataAtCell(index, hotInstance.propToCol("active"), "Active");
                if (isNullOrEmpty(nr.branchName))
                    hotInstance.setDataAtCell(index, hotInstance.propToCol("branchName"), defaultLocation);
            });
        }
        else {
            hotInstance.setDataAtCell(0, hotInstance.propToCol("active"), "Active");
            hotInstance.setDataAtCell(0, hotInstance.propToCol("branchName"), defaultLocation);
        }
    }

    onReset = () => {
    };

    getColumnData(emptyClients) {
        let columnDetailData = [];
        const hot = this.hotTableComponent.current.hotInstance;
        let columnDetails = { "ColumnName": string, "ColIndex": number, "ChangedRow": number }

        for (const element of emptyClients) {
            if (!element.clientType) {
                columnDetails = new Object();
                columnDetails.ChangedRow = element.index;
                columnDetails.ColumnName = "clientType";
                columnDetails.ColIndex = hot.propToCol(columnDetails.ColumnName);
                columnDetailData.push(columnDetails);
            }

            if (!element.last_CorporateName) {
                columnDetails = new Object();
                columnDetails.ChangedRow = element.index;
                columnDetails.ColumnName = "last_CorporateName";
                columnDetails.ColIndex = hot.propToCol(columnDetails.ColumnName);
                columnDetailData.push(columnDetails);
            }

            if (!element.branchName) {
                columnDetails = new Object();
                columnDetails.ChangedRow = element.index;
                columnDetails.ColumnName = "branchName";
                columnDetails.ColIndex = hot.propToCol(columnDetails.ColumnName);
                columnDetailData.push(columnDetails);
            }

            if (!element.active) {
                columnDetails = new Object();
                columnDetails.ChangedRow = element.index;
                columnDetails.ColumnName = "active";
                columnDetails.ColIndex = hot.propToCol(columnDetails.ColumnName);
                columnDetailData.push(columnDetails);
            }
        }
        return columnDetailData;
    }

    save() {
        const isInvalidInputExists = document.getElementsByClassName(' invalidEmptyCell');
        if (isInvalidInputExists != null) {
            if (isInvalidInputExists.length > 0) {
                this.props.showNotification(messages.VALID_CLIENT_DETAILS, notificationTypes.ERROR, this.getNotificationMargin());
                return;
            }
        }

        const hotInstance = this.hotTableComponent.current.hotInstance;

        const changedRows = [...new Set(this.dummyState.editedRows)];
        const updatedClients = [...new Set(this.dummyState.updatedClients)];

        const client = updatedClients;

        const changedClients = client
            .filter(elem => changedRows.includes(elem.clientId))
            .map((elem, i) => {
                elem.updated_by = logginedUser;
                elem.changedRowIndex = elem.physicalRow;
                elem.firmID = FIRM_ID;
                elem.clientID = elem.clientId;
                elem.clientTypeId = this.props.clientTypes && elem.clientType ? this.props.clientTypes.filter(el => el.clientTypeName === elem.clientType)[0].id : 0;
                elem.accountNumber = elem.accountNumber ? elem.accountNumber : "";
                elem.firstName = elem.firstName ? elem.firstName : "";
                elem.middleName = elem.middleName ? elem.middleName : "";
                elem.last_CorporateName = elem.last_CorporateName;
                elem.emailID = elem.emailId ? elem.emailId : "";
                elem.phoneNumber = elem.phoneNumber ? elem.phoneNumber : "";
                elem.branchName = elem.originatingLocationName = elem.branchName;
                elem.fiscalYear = elem.fiscalYear ? (elem.fiscalYear.split("/").length == 3 ? elem.fiscalYear : elem.fiscalYear + "/" + new Date().getFullYear()) : "1/1/1900";
                elem.active = elem.active == "Active" ? "Y" : "N";
                elem.branchId = elem.originatingLocation = this.props.locations && elem.branchName ? this.props.locations.filter(el => el.branchName.trim() === elem.branchName.trim())[0].branchID : 0;
                elem.generationType = elem.generationType?.trim() ?? "";
                elem.cparesponsibleId = elem.cparesponsibleId ? elem.cparesponsibleId : "0";
                let primaryTskCode = elem.primaryTaskCode ? elem.primaryTaskCode.toString().substring(elem.primaryTaskCode.lastIndexOf('(')).replace(/[()]/g, '').trim() : "";
                elem.primaryTaskID = this.props.primaryTaskTypes && primaryTskCode != "" ? this.props.primaryTaskTypes.filter(el => el.code.trim() === primaryTskCode || el.name.trim() === primaryTskCode)[0].id : 0;
                elem.clientGroups = [];

                let clientGroups = elem.groupName ? elem.groupName.split("|") : [];

                if (clientGroups.length > 0 && this.props.groupNames?.length > 0) {
                    clientGroups.forEach(cliGroup => {
                        let groupAry = cliGroup ? cliGroup.split(' - ') : [];

                        let group = null
                        if (groupAry.length == 1) {
                            group = this.props.groupNames.filter(el => el.groupName.trim() == cliGroup.trim())[0];
                        }
                        if (group == null) {
                            let groupName = "", groupNumber = "";
                            for (const i in groupAry) {
                                groupName = groupName.length > 0 ? groupName + " - " + groupAry[i] : groupAry[i];
                                groupNumber = i < (groupAry.length - 1) ? cliGroup.replace(groupName + ' - ', '') : "";
                                group = this.props.groupNames.filter(el => el.groupName.trim() == groupName && (groupNumber.length <= 0 || el.groupNumber == groupNumber))[0];
                                if (group != null) break;
                            }
                        }

                        if (group != null) {
                            elem.clientGroups.push({
                                CGS_GroupID: group.groupId,
                                GroupName: group.groupName,
                                CGS_Client_ID: elem.clientId,
                                CGS_FirmID: elem.firmID,
                                CGS_BranchID: elem.branchId,
                                Active: elem.active
                            });
                        }
                    });
                }

                return elem;
            });

        const allHotClients = hotInstance.getData()
            .map((item, index) =>
            ({
                clientType: item[3],
                last_CorporateName: item[7],
                branchName: item[11],
                active: item[15],
                index: index,
                client_Id: item[0]
            }));

        const emptyClients = allHotClients.filter(elem => isNullOrEmpty(elem.clientType) || isNullOrEmpty(elem.last_CorporateName) || isNullOrEmpty(elem.branchName) || isNullOrEmpty(elem.active));
        if (emptyClients.length > 0) {
            let colIndexes = this.getColumnData(emptyClients);
            for (const element of colIndexes) {
                hotInstance.setCellMeta(element.ChangedRow, element.ColIndex, "className", "invalidEmptyCell ");
            }
            hotInstance.render();

            this.props.showNotification(messages.VALID_CLIENT_DETAILS, notificationTypes.ERROR, this.getNotificationMargin());
            return;
        }

        let resArr = [];
        let isDuplicate = false;
        for (let item in changedClients) {
            if (changedClients[item]["last_CorporateName"] == null) changedClients[item]["last_CorporateName"] = "";
            if (changedClients[item]["middleName"] == null) changedClients[item]["middleName"] = "";
            if (changedClients[item]["firstName"] == null) changedClients[item]["firstName"] = "";
            if (changedClients[item]["generationType"] == null) changedClients[item]["generationType"] = "";
            if (changedClients[item]["accountNumber"] == null) changedClients[item]["accountNumber"] = "";

            let i = resArr.findIndex(x => (x.last_CorporateName == changedClients[item]["last_CorporateName"] && x.middleName == changedClients[item]["middleName"] && x.firstName == changedClients[item]["firstName"] && x.generationType == changedClients[item]["generationType"] && x.accountNumber == changedClients[item]["accountNumber"]));
            if (i <= -1) {
                let uniqueItem = {};
                uniqueItem.last_CorporateName = changedClients[item]["last_CorporateName"];
                uniqueItem.middleName = changedClients[item]["middleName"];
                uniqueItem.firstName = changedClients[item]["firstName"];
                uniqueItem.generationType = changedClients[item]["generationType"];
                uniqueItem.accountNumber = changedClients[item]["accountNumber"];
                resArr.push(uniqueItem);
            }
            else {
                isDuplicate = true;
                break;
            }
        };

        if (isDuplicate) {
            this.props.showNotification(messages.ALREADY_EXISTS, notificationTypes.ERROR, this.getNotificationMargin());
            return;
        }

        this.props.showLoader(true, "Please wait. Changes are being saved.");
        const request = this.props.saveEdits(changedClients, this.props.clients);
        request.then((res) => {
            if (res.payload.clientsReportData) {
                if (res.payload.clientsReportData.isSuccess) {
                    if (res.payload.clientsReportData.data) {
                        res.payload.clientsReportData.data.forEach(cli => {
                            let updatedClientData = hotInstance.getSourceDataAtRow(cli.item1);
                            if (updatedClientData != null && updatedClientData.clientId <= 0) {
                                updatedClientData.clientId = cli.item2;
                                let colIndex = hotInstance.propToCol("integrationStatus");
                                hotInstance.setCellMeta(cli.item1, colIndex, "href", "//");
                            }
                        });
                    }

                    this.dummyState.editedRows = [];
                    this.dummyState.updatedClients = [];
                    this.props.isEdited(false);
                    this.disableHeaderCheckBox(this.props.edited);
                    this.props.showNotification(`Saved Successfully`, notificationTypes.SUCCESS);
                    this.props.updateDefaultClients(this.props.clients);
                } else {
                    this.props.showNotification(res.payload.clientsReportData.msg, notificationTypes.ERROR, this.getNotificationMargin());
                }
            }
            this.props.showLoader(false);
        })
    };

    integrationRenderer(instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        let rowData = cellProperties.instance.getSourceDataAtRow(
            cellProperties.instance.toPhysicalRow(row)
        );
        if (this.isAddClientClicked) {
            td.innerHTML = "<a href = 'javascript:void(0)'> Link </a>";
        }
        if (rowData != null && rowData.clientId != "") {
            if (value == 'Unlink') {
                td.innerHTML = "<a href='javascript:void(0)'>Unlink</a>";
            }
            else {

                td.innerHTML = "<a href='//'>Link</a>";
            }
        }
    }

    dolinkdelete(isClientGuid) {
        var RedirectUrldeleteclient = window.parent.location.origin + "/xcmv2/CPAUtilities/DelinkClients?clientguid=" + isClientGuid;
        window.open(RedirectUrldeleteclient, "_self");
    }

    unLinkClientsOnConfirmation = async () => {
        const hotInstance = this.hotTableComponent.current.hotInstance;
        let selectedRow = hotInstance.getDataAtRow(this.currentRow);
        let clientId = selectedRow[hotInstance.propToCol("clientId")];
        let isClientGuid = selectedRow[hotInstance.propToCol("isClientGuid")];
        if (isClientGuid) {
            this.dolinkdelete(isClientGuid);
        }
        const request = await this.props.unlinkClients(clientId);

        if (request.payload.unlinkRequest) {
            if (request.payload.unlinkRequest.isSuccess) {
                this.props.showLoader(true, messages.REFRESHING_DATA);
                this.props.fetchAllClients(FIRM_ID, {
                    taskTypes: this.props.primaryTaskTypes
                }, BRANCH_ID, GLOBAL_USER, CLIENT_ID).then(() => { this.props.showLoader(false); });
                hotInstance.updateSettings(this.settings);
                hotInstance.loadData(this.props.clients);
                hotInstance.render();
                this.closeConfirmationPopup();
            }
        }
    }

    afterFilterHandler(conditionsStack) {
        if (this.hotTableComponent.current === null) {
            return;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        let afterFilterRowsCount = hot.getData().length;
        this.props.getRowsCountAfterFilter(afterFilterRowsCount);
        this.filterUserStatus = false;
        const showFilter = document.querySelector('.xcm-icon-filter-clear');
        if (showFilter != null) {
            showFilter.style.visibility = 'visible';
        }
    }

    afterLoadDataHandler(initialLoad) {
        if (
            !this.props.clients.length ||
            this.hotTableComponent.current === null
        ) {
            return;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        if (this.filterUserStatus) {
            var filterPlugin = hot.getPlugin("Filters");
            filterPlugin.addCondition(10, "by_value", [["Active"]]);
            filterPlugin.filter();
        }

    }

    afterGetColHeaderHandler(col, TH) {
        if (col == 1 || col == 2 || col == 16) {
            const button = TH.querySelector('.changeType');
            if (!button) {
                return;
            }
            button.parentElement.removeChild(button);
        }
        var editableFields = [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
        if (editableFields.includes(col)) {
            TH.classList.add("editable");
        }
        return;
    }

    beforeRowRenderHandler(TD, row, column, prop, value, cellProperties) {
        const parentElement = TD.parentElement;
        if (parentElement === null) return;

        if (cellProperties.instance.getDataAtCell(row, 1)) {
            Handsontable.dom.addClass(parentElement, "selected");
        } else {
            Handsontable.dom.removeClass(parentElement, "selected");
        }
    };

    afterOnCellMouseDownHandler(event, cellCoords, TD) {
        if (
            !this.hotTableComponent ||
            !this.hotTableComponent.current ||
            !this.hotTableComponent.current.hotInstance
        ) {
            return;
        }
        const hot = this.hotTableComponent.current.hotInstance;
        let selectedRow = hot.getDataAtRow(cellCoords.row);
        if (cellCoords.row === -1 && cellCoords.col === 1) {
            this.setCheckBoxHeaderOption();
            let getData = hot.getData();
            this.isEventBySelectAll = true;
            if (getData.length >= 50) {
                for (var i = 0; i < 50; i++) {
                    getData[i][1] = this.isSelectAllChecked;
                }
                hot.populateFromArray(0, 0, getData, 49, 1);
            } else {
                for (var i = 0; i < getData.length; i++) {
                    getData[i][1] = this.isSelectAllChecked;
                }
                hot.populateFromArray(0, 0, getData, getData.length - 1, 1);
            }
        }
        var clientId = selectedRow[hot.propToCol("clientId")];
        var integrationStatus = selectedRow[hot.propToCol("integrationStatus")];
        if (cellCoords.col === 17 && integrationStatus == 'Link' && clientId > 0) {
            var staticValue = "1";
            var RedirectUrl = window.parent.location.origin + "/xcmv2/XCM/ISClientSearchLink.aspx?clientid=" + clientId + "&Hide=" + staticValue + "&CIU=" + staticValue + "&DIFF=" + staticValue;
            window.open(RedirectUrl);
        }
        if (cellCoords.col === 17 && integrationStatus == 'Unlink') {
            if (clientId > 0) {
                this.setState({ isUnlinkClients: true });
                this.ShowConfirmationPopup()
                this.currentRow = cellCoords.row;
            }
        }
        if (cellCoords.col === 2 && selectedRow[hot.propToCol("axcessClientGuid")] != null) {
            let clientGuId = selectedRow[hot.propToCol("axcessClientGuid")];
            this.redirectToAxcessProfile(clientGuId);
        }
        if (cellCoords.col === 16) {
            let clientId = selectedRow[hot.propToCol("clientId")];
            if (clientId > 0) {
                this.ShowStaffAssignmentPopup();
                this.staffDetails = this.props.staffAssignmentLookUp(FIRM_ID, clientId);
                setTimeout(() => {
                    this.setState({
                        staffDet: this.props.staffDetails,
                        selectedRowDet: selectedRow,
                    });

                }, 2000);
                this.currentRow = cellCoords.row;
            }
        }
    }

    handleHOTChangeBefore = (changes, sources) => {
        if (sources == "ContextMenu.rowBelow" || sources === "ObserveChanges.change") {
            return;
        }
        if (sources !== "edit") {
            return;
        }

        // if there is no change then there is no need to validate
        if (changes[0][2] === changes[0][3]) {
            return;
        }

        switch (changes[0][1]) {
            case 'clientType':
                if (changes[0][3] == "") {
                    changes[0][3] = changes[0][2]

                    this.props.showNotification(`${changes[0][1] === "clientType" ? "Client type" : ""} should not be empty.`, notificationTypes.ERROR, this.getNotificationMargin());
                }
                let row = changes[0][0];
                const hot = this.hotTableComponent.current.hotInstance;
                let clientType = changes[0][3];

                if (clientType == "Entity") {
                    hot.setDataAtCell(row, hot.propToCol("firstName"), "");
                    hot.setDataAtCell(row, hot.propToCol("middleName"), "");
                    hot.setDataAtCell(row, hot.propToCol("generationType"), "");
                }
                break;

            case 'lastName':
                if (changes[0][3] == "") {
                    changes[0][3] = changes[0][2]

                    this.props.showNotification(`Last name should not be empty.`, notificationTypes.ERROR, this.getNotificationMargin());
                }
                this.updateClients(changes, changes[0][1]);
                break;
            case 'firstName':
            case 'middleName':
                if (changes[0][3] != "") {
                    this.updateClients(changes, changes[0][1]);
                }
                break;
            case 'emailId':
                this.emailValidation(changes, changes[0][1]);
                break;
            case "phoneNumber":
                this.phoneValidation(changes, changes[0][1]);
                break;
            case "groupNumber":
                this.numberValidation(changes, changes[0][1]);
                break;
            case "fiscalYear":
                this.dateValidation(changes, 'MM/DD');
                break;
            case "active":
                if (changes[0][3] == "") {
                    changes[0][3] = changes[0][2]
                    this.props.showNotification(`Status should not be empty.`, notificationTypes.ERROR, this.getNotificationMargin());
                }
                break;
        }

    };

    cellsHandler = (row, column) => {
        let cp = {};
        var data;
        if (this.hotTableComponent.current != undefined) {
            const hot = this.hotTableComponent.current.hotInstance;
            data = hot.getDataAtCell(row, 0);
            if (this.props.firmSettings?.onlyUpdate == "Y" && data != 0) {
                cp.readOnly = true;
                cp.className = "wkusergriddisabled";
            }
            if (roleSupervisor_Preparer && data != 0) {
                if (column == hot.propToCol("clientType") || column == hot.propToCol("firstName") ||
                    column == hot.propToCol("middleName") || column == hot.propToCol("last_CorporateName") ||
                    column == hot.propToCol("accountNumber") || column == hot.propToCol("generationType")
                    || column == hot.propToCol("fiscalYear") || column == hot.propToCol("branchName")) {
                    cp.readOnly = true;
                }
                else {
                    cp.readOnly = false;
                }
            }
            if (this.props.edited) {
                if (column === 1) {
                    cp.readOnly = true;
                }
            }

        }
        return cp

    }

    updateClients(changes, type) {
        // validation for name 100 characters limit 
        if (type === "lastName" || type === "firstName" || type === "middleName") {
            if (changes[0][3] != '' && changes[0][3] != null && changes[0][3].length > 80) {
                changes[0][3] = changes[0][2]

                this.props.showNotification(`${changes[0][1] === "firstName" ? "First Name" : changes[0][1] === "middleName" ? "Middle Name" : "Last name"} should not contain more than 80 characters.`, notificationTypes.ERROR, this.getNotificationMargin());
            }
        }
    }

    emailValidation(changes, type) {
        this.invalidInput = false;
        // length & special characters validation - replaces to old value incase invalid entry
        if (changes[0][3] &&
            (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(changes[0][3]))
        ) {
            this.invalidInput = true;
            this.props.showNotification(`Invalid email Id`, notificationTypes.ERROR, this.getNotificationMargin());
        }
    }

    phoneValidation(changes, type) {
        this.invalidInput = false;
        var phoneNo = changes[0][3];
        // length & special characters validation - replaces to old value incase invalid entry
        if (phoneNo && !/^\d{10}$|^$/.test(phoneNo)) {
            this.invalidInput = true;
            this.props.showNotification(`Enter valid 10 digit phone number (Example: 123*******).`, notificationTypes.ERROR, this.getNotificationMargin());
        } else if (phoneNo == '' || phoneNo == null) {
            changes[0][3] = '';
        } else {
            changes[0][3] = '(' + phoneNo.slice(0, 3) + ')' + phoneNo.slice(3, 6) + '-' + phoneNo.slice(6, 10);
        }
    }

    numberValidation(changes, type) {
        // length & special characters validation - replaces to old value incase invalid entry

        if (
            changes[0][3] &&
            (!/^[-\(\) ]*([0-9][-\(\) ]*){3,50}$|^$/.test(changes[0][3]))) {
            changes[0][3] = changes[0][2];

            this.props.showNotification(`Enter valid number`, notificationTypes.ERROR, this.getNotificationMargin());
        }
    }

    dateValidation(changes, dateFormat) {
        let inputAry = changes[0][3].split("/");
        let isValid = false;
        let mm, dd;
        if (inputAry.length == 2) {
            mm = inputAry[0].length == 1 ? ("0" + inputAry[0]).slice(-2) : inputAry[0];
            dd = inputAry[1].length == 1 ? ("0" + inputAry[1]).slice(-2) : inputAry[1];
            isValid = inputAry.length == 2 && moment(mm + "/" + dd + "/" + new Date().getFullYear(), (dateFormat + "/YYYY"), true).isValid();
        }

        this.invalidInput = false;
        if (!isValid) {
            this.invalidInput = true;
            this.props.showNotification(`Invalid fiscal year format. Accepted format is ` + dateFormat, notificationTypes.ERROR, this.getNotificationMargin());
        } else {
            changes[0][3] = mm + "/" + dd;
        }
    }

    handleHOTChange = (changes, sources) => {
        if (changes === null || this.hotTableComponent.current === null || sources === "loadData" || sources === "ObserveChanges.change") { return; }

        const hot = this.hotTableComponent.current.hotInstance;
        if (sources == "edit") {
            if (changes[0][2] === changes[0][3]) {
                if (!this.invalidInput) {
                    hot.setCellMeta(changes[0][0], hot.propToCol(changes[0][1]), "className", this.props.edited ? "editedCellColor" : "");
                    hot.render();
                }
                return;
            }
        }

        if ((changes[0][1] == "firstName" || changes[0][1] == "middleName") && changes[0][3] == "" && hot.getCellMeta(changes[0][0], 4).readOnly == true) {
            return;
        }

        var regExp = /\(([^)]+)\)/;

        if (changes[0][1] == "primaryTaskCode" && changes[0][3] != "" && changes[0][3] != null && changes[0][2] != null && changes[0][2].length > 0) {
            let prevVal = regExp.exec(changes[0][3]);
            if (prevVal != null && prevVal.length >= 1 && changes[0][2] === prevVal[1])
                return;
        }

        if (sources === "populateFromArray") {
            let getSelectedData = changes
                .filter(el => el[3] == true)
                .map((el, i) => {
                    return hot.getSourceDataAtRow(hot.toPhysicalRow(el[0]));
                })
                .map(el => {

                    return {
                        clientId: el.clientId,
                    };
                });



            const clientIds = getSelectedData.map(el => el.clientId);
            if (clientIds.length) {
                this.props.selectedClients(clientIds);
            } else {
                this.props.selectedClients([]);
            }
        }

        if ((sources === "edit" || sources === "Autofill.fill") && changes[0][1] === "selected") {
            let uncheckedData = hot.getData().filter(el => el[1] == null || el[1] == false);
            if (uncheckedData.length >= 1) {
                this.setCheckBoxHeaderOptionFromSingleSelect(false);
                this.isSelectAllChecked = false;
            } else {
                this.setCheckBoxHeaderOptionFromSingleSelect(true);
                this.isSelectAllChecked = false;
            }
            changes.map(element => {
                let physicalRow = hot.toPhysicalRow(element[0]);
                let newlySelectedClient = this.props.clients[physicalRow];

                let selectedClientsData = this.props.selectedClientsIds;
                //******************
                if (element[3] === true) {
                    let clientIndex = selectedClientsData.indexOf(newlySelectedClient.clientId);
                    if (clientIndex < 0) {
                        selectedClientsData.push(newlySelectedClient.clientId);
                    }
                } else {
                    let clientIndex = selectedClientsData.indexOf(newlySelectedClient.clientId);
                    if (clientIndex > -1) {
                        selectedClientsData.splice(clientIndex, 1);
                    }
                }
                this.props.selectedClients(selectedClientsData);
            });
        }

        if (changes[0][1] != "selected") {
            changes.map(change => {
                let changedClientsId = hot.getDataAtRow(change[0])[0];
                let changedRowIndex = change[0];
                let physicalRow = hot.toPhysicalRow(changedRowIndex);
                let updatedClientData = hot.getSourceDataAtRow(physicalRow);
                updatedClientData.physicalRow = physicalRow;
                if (updatedClientData.clientId == null)
                    updatedClientData.clientId = 0;
                let index = this.dummyState.updatedClients.findIndex(
                    client => client.clientId == updatedClientData.clientId && client.physicalRow == updatedClientData.physicalRow
                );

                if (index >= 0) {
                    this.dummyState.updatedClients.splice(index, 1);
                }

                this.dummyState.updatedClients.push({ ...updatedClientData });

                if (changedClientsId == null) { changedClientsId = 0 }
                if (!this.dummyState.editedRows.includes(changedClientsId)) {
                    this.dummyState.editedRows.push(changedClientsId);
                }
            });
        }
        if ((sources === "edit" || sources === "Autofill.fill") && changes[0][1] !== "selected") {
            changes.map(element => {
                let changedColIndex = hot.propToCol(element[1]);
                let changedRowIndex = element[0];
                if (element[2] !== element[3]) {
                    if (!this.props.edited) {
                        this.props.isEdited(true);
                        this.disableHeaderCheckBox(true);
                    }
                    var className = "editedCellColor";
                    if (this.invalidInput) { className += " invalidEmptyCell"; }
                    hot.setCellMeta(
                        changedRowIndex,
                        changedColIndex,
                        "className",
                        className
                    );
                }
            });
        }

        this.hotTableComponent.current.hotInstance.render();
    };

    discardChangesOnYes = () => {
        this.RemoveEmptyRow();
        this.props.discardChanges();
        this.disableHeaderCheckBox(false);
        this.dummyState.editedRows = [];
        this.dummyState.updatedClients = [];
        this.props.showNotification("Changes discarded successfully", notificationTypes.SUCCESS);
        this.closeConfirmationPopup();
        const hotInstance = this.hotTableComponent.current.hotInstance;
        if (isStaffModified) {
            this.props.showLoader(true);
            this.props.fetchAllClients(FIRM_ID, {
                taskTypes: this.props.primaryTaskTypes
            }, BRANCH_ID, GLOBAL_USER, CLIENT_ID, this.selectedSearchFilter).then(() => { this.props.showLoader(false); });
            hotInstance.updateSettings(this.settings);
        }
        hotInstance.loadData(this.props.clients);
        this.props.getRowsCountAfterFilter(hotInstance.getData().length);
        hotInstance.render();
    }

    discardChangesOnCancel = () => {
        this.props.showNotification("Changes discarded successfully", notificationTypes.SUCCESS);
        this.closeConfirmationPopup();
    }

    showLoader(flag, message) {
        return (flag ? (
            <Dimmer page active inverted inverted>
                <Loader inverted>{message}</Loader>
            </Dimmer>) : "");
    }

    handleClearFilters = () => {
        if (this.hotTableComponent.current === null) return;
        const hot = this.hotTableComponent.current.hotInstance;
        var filterPlugin = hot.getPlugin("Filters");
        filterPlugin.clearConditions();
        filterPlugin.filter();
        this.setCheckBoxHeaderOptionFromSingleSelect(false);
        this.disableHeaderCheckBox(this.props.edited);
        this.isSelectAllChecked = false;
        this.props.clearAllFilters(false, this.props.clients);
    }

    RemoveEmptyRow() {
        const hotInstance = this.hotTableComponent.current.hotInstance;
        var rowCount = hotInstance.countRows();
        for (var i = rowCount - 1; i >= 0; i--) {
            if (hotInstance.getDataAtCell(i, 0) == null || hotInstance.getDataAtCell(i, 0) == 0) {
                hotInstance.alter('remove_row', i, 1);
            }
            else {
                continue
            }

        }
    }

    showAddClientBtn() {
        return (
            <Button
                primary
                title="Add Client/Entity"
                onClick={this.onClick}
            >  <svg className={`svg_icon xcm-icon-plus size-20`}>
                    <use xlinkHref={`${svg_icon_path}#xcm-icon-plus`}> </use>
                </svg>Add Client/Entity
            </Button>
        );
    }

    updateLoaderVisibility(flag) {
        let $loader = document.querySelector(".active.visible");
        if ($loader) {
            $loader.style.setProperty("display", flag ? "flex" : "none", "important")
        }
    }

    renderTopFilters() {
        return (
            <form className="ui form ml-6 mr-12" autoComplete="off" onSubmit={this.searchClients.bind(this)} ref={this.filterComponent}>
                <div className="six fields">
                    <div className="field">
                        <label>Status</label>
                        <select className="ui search dropdown" name="status">
                            <option value="">--Select--</option>
                            <option value="Y">Active</option>
                            <option value="N">Inactive</option>
                        </select>
                    </div>
                    <div className="field">
                        <label>Origination Location</label>
                        <select className="ui search dropdown" name="location">
                            <option value="0">--Select--</option>
                            {
                                this.props.locations.map((opt, i) => (

                                    <option key={i} value={opt.branchID}>{opt.branchName}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="field">
                        <label>Client/Entity Type</label>
                        <select className="ui search dropdown" name="clientType">
                            <option value="0">--Select--</option>
                            {
                                this.props.clientTypes.map((opt, i) => (
                                    <option key={i} value={opt.id}>{opt.clientTypeName}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="field">
                        <label>Primary Task Type</label>
                        <select className="ui search dropdown" name="primaryTaskType">
                            <option value="">--Select--</option>
                            {
                                this.props.primaryTaskTypes.map((opt, i) => (
                                    <option key={i} value={opt.id}>{opt.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="six wide field">
                        <label>Search by Last/Entity Name or Number</label>
                        {(this.props.clients.length == 1) ?
                            <input type="text" name="searchText" className="ui input" defaultValue={this.props.clients[0].last_CorporateName} /> :
                            <input type="text" name="searchText" className="ui input" placeholder="Enter value" />
                        }
                    </div>
                    <div className="two wide field">
                        <label>&nbsp;</label>
                        <button className="ui primary button fluid" type="submit">
                            Search
                        </button>
                    </div>
                </div>
            </form>
        );
    }

    renderBottomInfoBanner() {
        return (
            this.props.showInfoBanner ? (
                <div className="ui info message ml-4 mr-4" id="divInfoBanner">
                    <div className="header">
                        There are too many client records to display. Only top 10,000 records are displayed. Please use at least one search criteria to view desired results.
                    </div>
                </div>) : false);
    }

    renderHotTable() {
        this.Columns = [
            {
                data: "clientId",
                type: "text",
                readOnly: true
            },
            {
                data: "selected",
                type: "checkbox",
                columnSorting: {
                    indicator: false,
                    headerAction: false,
                    compareFunctionFactory: function compareFunctionFactory() {
                        return function comparator() {
                            return 0; // Don't sort the first visual column.
                        };
                    }
                }

            },
            {
                data: "axcessClientGuid",
                renderer: ccr.portalIconRenderer.bind(this),
                columnSorting: {
                    indicator: false,
                    headerAction: false,
                    compareFunctionFactory: function compareFunctionFactory() {
                        return function comparator() {
                            return 0; // Don't sort the first visual column.
                        };
                    }
                },
                readOnly: false,
                editor: false,
                skipColumnOnPaste: true,

            },
            {
                data: "clientType",
                type: "dropdown",
                readOnly: false,
                renderer: ccr.customDropdownRendererPlaceholder.bind(this),
                editor: MultiSelectEditor,
                selector: "clientTypes",
                cellValidator: cellValidator.typeValidator,
                invalidCellClassName: "htInvalid",
                allowInvalid: false,
                allowEmpty: false,
                properties: { id: "id", label: "name", value: "name" },
                selectOptions: {
                    data: null
                }

            },
            {
                data: "accountNumber",
                type: "text",
                readOnly: false,
                allowInvalid: false,
                invalidCellClassName: "htInvalid",
                renderer: ccr.setPlaceholder.bind(this),
                validator: cellValidator.maxLengthValidator
            },
            {
                data: "firstName",
                type: "text",
                allowInvalid: false,
                invalidCellClassName: "htInvalid",
                renderer: ccr.firstNameRenderer.bind(this)
            },
            {
                data: "middleName",
                type: "text",
                allowInvalid: false,
                invalidCellClassName: "htInvalid",
                renderer: ccr.middleNameRenderer.bind(this)
            },
            {
                data: "last_CorporateName",
                type: "text",
                invalidCellClassName: "htInvalid",
                allowEmpty: false,
                isRequired: true,
                renderer: ccr.lastNameRenderer.bind(this)
            },
            {

                data: "generationType",
                type: "dropdown",
                allowInvalid: false,
                renderer: ccr.customDropdownRendererPlaceholder.bind(this),
                editor: MultiSelectEditor,
                selector: "suffix",
                properties: { id: "id", label: "name", value: "name" },
                selectOptions: {
                    data: null
                }

            },
            {
                data: "emailId",
                type: "text",
                readOnly: false,
                allowInvalid: false,
                invalidCellClassName: "htInvalid",
                renderer: ccr.setPlaceholder.bind(this)
            },
            {
                data: "phoneNumber",
                type: "text",
                allowInvalid: false,
                invalidCellClassName: "htInvalid",
                renderer: ccr.setPlaceholder.bind(this)
            },
            {

                data: "branchName",
                type: "dropdown",
                readOnly: GLOBAL_USER === "Y" && FIRM_ID != XPITAX_ID ? false : true,
                className: GLOBAL_USER === "Y" && FIRM_ID != XPITAX_ID ? "" : "wkusergriddisabled",
                allowInvalid: false,
                renderer: ccr.customDropdownRendererPlaceholder.bind(this),
                editor: MultiSelectEditor,
                selector: "locations",
                properties: { id: "id", label: "name", value: "name" },
                selectOptions: {
                    data: null
                }


            },
            {

                data: "groupName",
                type: "dropdown",
                allowInvalid: false,
                renderer: ccr.customDropdownRendererPlaceholder.bind(this),
                editor: MultiSelectEditor,
                selector: "clientGroups",
                properties: { id: "id", label: "name,groupNumber", value: "name" },
                selectOptions: {
                    multiple: true,
                    data: null
                },

            },

            {

                data: "primaryTaskCode",
                type: "dropdown",
                allowInvalid: false,
                renderer: ccr.customDropdownRendererPlaceholder.bind(this),
                editor: MultiSelectEditor,
                selector: "taskTypes",
                properties: { id: "id", label: "name,code", value: "name" },
                selectOptions: {
                    data: null
                }
            },
            {

                data: "fiscalYear",
                type: "text",
                allowInvalid: false,
                renderer: ccr.setPlaceholder.bind(this)
            },
            {

                data: "active",
                type: "dropdown",
                allowInvalid: false,
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    data: [
                        {
                            id: "1",
                            label: "Active",
                            value: "Active"
                        },
                        {
                            id: "2",
                            label: "Inactive",
                            value: "Inactive"
                        }
                    ]
                }
            },
            {

                data: "cparesponsibleId",
                renderer: ccr.iconRenderer.bind(this),
                readOnly: false,
                editor: false,
                skipColumnOnPaste: true,
            },
            {
                data: "integrationStatus",
                renderer: this.integrationRenderer.bind(this),
                readOnly: false,
                editor: false,
                skipColumnOnPaste: true,
            },
            {
                data: "isClientGuid",
                type: "text",
                readOnly: true
            },
            {
                data: "fullName",
            }

        ];
        if (Object.keys(this.props.clientTypes).length) {
            this.runForAllColumns();
        }

        return (
            <HotTable
                id="clientsHot"
                className="usertable"
                ref={this.hotTableComponent}
                settings={this.settings}
                data={this.props.clients}
                width="100%"
                height={this.props.showInfoBanner ? (this.props.edited ? "calc(100vh - 276px)" : "calc(100vh - 218px)") : (this.props.edited ? "calc(100vh - 200px)" : "calc(100vh - 170px)")}
                colHeaders={colHeaders}
                colWidths={colWidths}
                columns={this.Columns}
                cells={this.cellsHandler}
                afterGetColHeader={this.afterGetColHeaderHandler}
                beforeRenderer={this.beforeRowRenderHandler.bind(this)}
                afterFilter={this.afterFilterHandler.bind(this)}
                afterChange={(changes, source) =>
                    this.handleHOTChange(changes, source)
                }
                beforeChange={(changes, source) => {
                    this.handleHOTChangeBefore(changes, source);
                }}
                afterOnCellMouseDown={this.afterOnCellMouseDownHandler.bind(this)}
                // this is for prevention of page error issue when click delete / backspace on a cell
                beforeKeyDown={(event) => {
                    if (event.keyCode === 46 || event.keyCode === 8) {
                        event.stopImmediatePropagation()
                    }
                }}
                style={{ marginLeft: "4px" }}
            />);
    }

    renderActionButtons() {
        return (
            <div id="buttons" >
                {this.props.edited ? (
                    <Grid padded textAlign="right">
                        <Grid.Row columns={2}>
                            <Grid.Column textAlign="left">
                            </Grid.Column>
                            <Grid.Column>
                                <Modal
                                    className="confirmModal float right"
                                    trigger={<Button>Cancel</Button>}
                                    closeIcon
                                    header={{ content: "Warning", className: "bold" }}
                                    closeOnDimmerClick={false}
                                    centered={true}
                                    size="tiny"
                                    content="The changes you have made will be discarded. Do you want to proceed?"
                                    actions={[
                                        {
                                            key: 1,
                                            content: "No",
                                            triggerclose: "true"
                                        },
                                        {
                                            key: 2,
                                            className: "primary",
                                            content: "Yes",
                                            triggerclose: "false",
                                            onClick: this.discardChangesOnYes.bind(this)
                                        }
                                    ]}
                                >
                                </Modal>
                                <Button primary onClick={this.save.bind(this)} title="Save Edit">
                                    Save
                                </Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                ) : <span />}
            </div>);
    }

    async searchClients(event) {
        event.preventDefault();

        if (this.props.clients.length == 0) {
            this.updateLoaderVisibility(true);
        } else {
            this.props.showLoader(true, "Please wait. Search is in progress.");
        }

        var clearFilterIcon = document.querySelector('.xcm-icon-filter-clear');
        if (clearFilterIcon != null && clearFilterIcon.style.visibility === 'visible') {
            clearFilterIcon.style.visibility = 'hidden';
            this.handleClearFilters();
        }

        var searchCriteria = {
            status: event.target.status.value, location: event.target.location.value,
            clientType: event.target.clientType.value, primaryTaskType: event.target.primaryTaskType.value,
            searchText: event.target.searchText.value
        };

        this.selectedSearchFilter = searchCriteria;

        this.props.isEdited(false);

        const hotInstance = this.hotTableComponent.current.hotInstance;

        this.props.fetchAllClients(FIRM_ID, { taskTypes: this.props.primaryTaskTypes }, BRANCH_ID, GLOBAL_USER, 0, searchCriteria)
            .then(() => {
                this.props.showLoader(false);

                if (this.props.clients.length <= 0) {
                    hotInstance.updateSettings(this.settings);
                    hotInstance.loadData(this.props.clients);
                    hotInstance.render();
                    this.updateLoaderVisibility(false);
                    if (document.getElementById("divInfoBanner"))
                        document.getElementById("divInfoBanner").style.visibility = 'hidden';
                } else {
                    hotInstance.updateSettings(this.settings);
                    hotInstance.loadData(this.props.clients);
                    hotInstance.render();
                }
            });
    }

    getNotificationMargin() {
        return this.props.edited ? "7%" : null;
    }

    render() {
        return (
            <>
                <Container fluid>
                    <ConfirmationModal
                        showPopup={this.state.showPopup}
                        closePopup={this.closeConfirmationPopup}
                        discardChangesYes={this.discardChangesOnYes}
                        isUnlinkClients={this.state.isUnlinkClients}
                        unlinkClients={this.unLinkClientsOnConfirmation}
                    />
                    <StaffAssignmentModal
                        showStaffAssignmentPopup={this.state.showStaffAssignmentPopup}
                        closeStaffAssignmentPopup={this.closeStaffAssignmentPopup}
                        discardChangesOnCancel={this.discardChangesOnCancel}
                        staffDet={this.state.staffDet}
                        firm={FIRM_ID}
                        role={RoleId}
                        clientDet={this.state.selectedRowDet}
                    />

                    {this.renderTopFilters()}
                    {this.renderHotTable()}
                    {this.renderBottomInfoBanner()}
                    {this.renderActionButtons()}
                    {this.showLoader(this.props.shouldShowLoader, this.props.loaderMessage)}
                </Container>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        clients: state.allClients.clients,
        clientTypes: state.allClients.clientTypes,
        suffix: state.allClients.suffix,
        locations: state.allClients.locations,
        groupNames: state.allClients.groupNames,
        primaryTaskTypes: state.allClients.primaryTaskTypes,
        statuses: state.allClients.statuses,
        isClearFilters: state.allClients.isClearFilters,
        shouldShowLoader: state.allClients.showLoader,
        loaderMessage: state.allClients.loaderMessage,
        edited: state.allClients.edited,
        selectedClientsIds: state.allClients.selectedClients.selectedClientsIds,
        createNotification: state.allClients.createNotification,
        isAddNewClient: state.allClients.isAddNewClient,
        firmSettings: state.allClients.firmSettings,
        clientDataById: state.allClients.clientDataById,
        isUnlinkClients: state.allClients.isUnlinkClients,
        staffDetails: state.allClients.staffDetails,
        showInfoBanner: state.allClients.showInfoBanner
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fetchAllClients,
            fetchClientTypeLookUp,
            fetchGenerationTypeLookUp,
            fetchLocationLookUp,
            fetchTaskTypeLookUp,
            fetchGroupLookUp,
            clearAllFilters,
            getRowsCountAfterFilter,
            discardChanges,
            showLoader,
            isEdited,
            saveEdits,
            createNotification,
            selectedClients,
            addNewClient,
            fetchFirmSettings,
            fetchClientById,
            unlinkClients,
            staffAssignmentLookUp,
            showNotification,
            updateDefaultClients
        },
        dispatch
    );
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClientsTable);


